/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";

const APP_BASE_RAW = process.env.PUBLIC_URL || "";
const APP_BASE =
  APP_BASE_RAW && APP_BASE_RAW !== "/" ? APP_BASE_RAW.replace(/\/+$/, "") : "";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path={`${APP_BASE}/admin/*`} element={<AdminLayout />} />
      <Route path={`${APP_BASE}/auth/*`} element={<AuthLayout />} />
      <Route path="/admin/*" element={<AdminLayout />} />
      <Route path="/auth/*" element={<AuthLayout />} />
      <Route path="/" element={<Navigate to={`${APP_BASE}/admin/index`} replace />} />
      <Route path="*" element={<Navigate to={`${APP_BASE}/admin/index`} replace />} />
    </Routes>
  </BrowserRouter>
);
